<template>
  <div>
    <el-row
      type="flex"
      :gutter="20"
      class="agreement-row"
    >
      <RowActions
        :columnNumbers="columns.length"
        @removeRow="$emit('removeRow', rowIndex)"
        @columnChange="v => $emit('columnChange', v, rowIndex)"
      />
      <el-col
        :span="24/columns.length"
        class="agreement-col"
        v-for="(column, columnIndex) in columns"
        :key="columnIndex"
      >
        <AddElement
          v-show="column.contents.length === 0"
          @addElement="$emit('addElement', rowIndex, columnIndex, 1)"
          style="position: absolute; left: 50%; transform: translateX(-50%);"
        />
        <draggable
          class="dragArea list-group"
          group="element"
          :list="column.contents"
          v-bind="dragOptions"
          handle=".handle-element"
        >
          <div
            v-for="(content, contentIndex) in column.contents"
          >
            <EditorElement
              class="builder-list-group-item"
              :content="content"
              :displayFirstAdd="contentIndex === 0"
              :type="type"
              @addElement="$emit('addElement', rowIndex, columnIndex, contentIndex + 1)"
              @removeElement="$emit('removeElement', rowIndex, columnIndex, contentIndex)"
              @change="v => $emit('contentChange', v, rowIndex, columnIndex, contentIndex)"
            />
          </div>
        </draggable>
      </el-col>
    </el-row>
    <AddRow
      @addRow="$emit('addRow', rowIndex + 1)"
    />
  </div>
</template>

<script>
  import EditorElement from './elements/EditorElement';
  import AddElement from './elements/AddElement';
  import AddRow from './AddRow';
  import RowActions from './Actions';
  import draggable from 'vuedraggable';

  export default {
    props: ['columns', 'rowIndex', 'type'],
    computed: {
      dragOptions() {
        return {
          animation: 500,
          group: 'description',
          disabled: false,
          ghostClass: 'ghost'
        };
      }
    },
    components: {
      EditorElement,
      AddRow,
      AddElement,
      RowActions,
      draggable,
    }
  };
</script>

<style>
  .agreement-builder .agreement-row {
    padding: 38px 10px 10px 10px;
    position: relative;
    border: 1px dotted #eee;
    transition: 0.3s;
    border-radius: 3px;
  }

  .agreement-builder .agreement-row:hover {
    background: rgba(237, 245, 255, 0.62);
    transition: 0.3s;
  }

  .agreement-builder .agreement-col {
    border: 1px dotted #eee;
  }

  .agreement-builder .agreement-col {
    background: #ffffff;
    margin-bottom: 0;
    transition: 0.3s;
    border-radius: 3px;
    position: relative;
  }

  .agreement-builder .agreement-col:hover {
    background: rgb(237, 245, 255);
    transition: 0.3s;
  }

  .agreement-builder .agreement-col + .agreement-col {
    margin-left: 5px;
  }

  .list-group {
    min-height: 100px;
    height: 100%;
  }
</style>
